module.exports = __webpack_public_path__ + "img/bg_avatar_male_03.76a1a795.png";